import { Component, OnInit, OnDestroy, OnChanges, Input, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridOptions, } from 'ag-grid/main';
import { LoopBackFilter } from '../../../sdk/models/';
import { DataelementApi, AccountApi } from '../../../sdk/services/custom';
import { GridUtilities } from '../../../components/grid/GridUtilities';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
import zipcelx from 'zipcelx';

@Component({
    selector: 'table-widget',
    templateUrl: './table.component.html',
    providers: [DataelementApi],
    styleUrls: ['./table.component.scss']

})

export class TableWidgetComponent implements OnInit, OnChanges, OnDestroy {
    @Input() id: string;
    @Input() title = '';
    @Input() widget: any;
    @Input() height: any;
    @Input() disableCardWrapper: boolean = true;
    @Input() displaycolumns: string;
    @Input() dataelementrecords: any;
    @Input() entityrecordid: any;

    dataelement: any;
    gridOptions: any;
    entitytype = '';
    subscriptions: any = [];
    entity: any;
    entityname = '';
    rowData: any;
    fields: any;
    records: any = [];
    showCardWrapper = true;
    columns: any;
    gridheight: any = '300px';
    windowHeight: any;
    windowWidth: any;
    columnDefs = [];
    notifyOptions = PlatformApp.getNotificationOptions();
    constructor(private route: ActivatedRoute, private _DataelementApi: DataelementApi,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        private _account: AccountApi, private ngZone: NgZone) {
        this.windowHeight = window.innerHeight;
        window.onresize = (e) => {
            ngZone.run(() => {
                this.windowWidth = window.innerWidth;
                this.windowHeight = window.innerHeight;
            });
        };
    }

    private constructColumns(fields: any[]) {
        let columns = [];
        if (columns) {
            columns.push(...fields.map(f => { return { 'headerName': f.label, 'field': f.name, 'fieldtype': f.fieldtype }; }));
        }
        //If no fields have been set just return name
        if (columns.length < 1) {
            columns.push({
                headerName: 'Name',
                field: 'name'
            });
        }
        this.columns = columns;
    }

    private configureandloadgrid() {
        if (this.gridOptions && this.gridOptions.api) {
            this.replaceColumns();
            if (this.columns && this.displaycolumns && this.displaycolumns.length) {
                this.columns = this.setdisplaycolumns(this.columns, this.displaycolumns);
            }
            this.gridOptions.api.setColumnDefs(this.columns);
            if (Array.isArray(this.records) && this.records.length > 0) {
                this.gridOptions.api.setRowData(this.records);
            } else {
                this.gridOptions.api.setRowData([]);
            }
            this.gridOptions.api.sizeColumnsToFit();
        }
    }

    ngOnInit(): void {

        if (this.disableCardWrapper) {
            this.showCardWrapper = false;
        }
        if (this.height === '100%') {
            this.gridheight = (this.windowHeight - 60) + 'px';
        } else {
            this.gridheight = this.height;
        }

        this.getWidgetData();

        this.gridOptions = <GridOptions>{
            onGridReady: () => {
                this.gridOptions.rowHeight = 40;
                this.gridOptions.suppressCellSelection = true;
                this.gridOptions.enableColResize = true;
                this.gridOptions.enableSorting = true;
                this.gridOptions.enableStatusBar = false;
                this.gridOptions.groupUseEntireRow = false;
                this.gridOptions.groupIncludeFooter = true;
                this.gridOptions.groupDefaultExpanded = -1;
                this.gridOptions.animateRows = false;
                this.gridOptions.groupSuppressAutoColumn = true;
                this.gridOptions.paginationPageSize = 30;
                this.configureandloadgrid();
            },
            onRowClicked: () => {
                console.log('Row clicked');
            }
        };
    }

    ngOnChanges(changes) {
        if (changes && changes.dataelementrecords && !changes.dataelementrecords.firstChange) {
            if (this.dataelementrecords) {
                let datarecords = JSON.parse(JSON.stringify(this.dataelementrecords));
                if (Array.isArray(datarecords) || datarecords.length > 0) {
                    this.records = datarecords;
                    this.configureandloadgrid();
                }
            }
        }
    }

    private checkforDateColumn(column) {
        if (column.fieldtype === 'dateandtime' || column.fieldtype === 'date') {
            return true;
        } else {
            return false;
        }
    }

    public exportAsCSV() {
        let params = {
            skipHeader: false,
            columnGroups: true,
            skipFooters: true,
            skipGroups: false,
            skipFloatingTop: true,
            skipFloatingBottom: true,
            allColumns: true,
            onlySelected: false,
            suppressQuotes: false,
            fileName: this.title,
            columnSeparator: ';',
            processCellCallback: (parameters) => {
                if ((parameters.column.colDef.fieldtype === 'dateandtime'
                    || parameters.column.colDef.fieldtype === 'date'
                    || parameters.column.colDef.fieldtype === 'time'
                    || parameters.column.colDef.fieldtype === 'currency')
                    && parameters.value) {
                    return parameters.value.display;
                } else {
                    return parameters.value;
                }

            }
        };
        this.gridOptions.api.exportDataAsCsv(params);
    }

    public exportAsExcel() {
        let records = [];
        let row = [];
        let columns = this.gridOptions.columnApi.getAllDisplayedColumns();
        columns.forEach(c => {
            row.push({ value: c.getColDef().headerName, type: c.getColDef()['fieldtype'] });
        });
        records.push(row);
        this.gridOptions.api.forEachNode(rowd => {
            row = [];
            columns.forEach(c => {
                let col = { value: this._getValue(rowd.data, c.getColId()), type: c.getColDef()['fieldtype'] };
                row.push(col);
            });
            records.push(row);
        });
        let config = {
            filename: this.title,
            sheet: { data: records }
        };
        zipcelx(config);
    }

    private _getValue(obj, fieldName) {
        let names = fieldName.split('.');
        let o = obj;
        names.forEach(n => {
            if (o) {
                o = o[n];
            }
        });
        return o;
    }

    private replaceColumns() {
        if (this.columns) {
            for (let i = 0; i < this.columns.length; i++) {
                if (this.columns[i].cellRenderer && this.columns[i].cellRenderer === ':currency') {
                    this.columns[i].cellRenderer = GridUtilities.currencyRenderer;
                }
                if (this.columns[i].fieldtype === 'currency') {
                    this.columns[i].comparator = GridUtilities.numberComparator;
                    this.columns[i].cellRenderer = GridUtilities.currencyRenderer;
                }

                if (this.checkforDateColumn(this.columns[i])) {
                    this.columns[i].comparator = GridUtilities.dateComparator;
                    this.columns[i].cellRenderer = GridUtilities.dateRenderer;
                }

            }
        }
    }
    private setdisplaycolumns(datacolumns, displaycolumns) {
        for (let i = 0; i < datacolumns.length; i++) {
            datacolumns[i].hide = false;
            if (datacolumns[i].field) {
                if (displaycolumns.indexOf(datacolumns[i].field) > -1) {
                    datacolumns[i].hide = false;
                } else {
                    datacolumns[i].hide = true;
                }
            }
        }
        return datacolumns;
    }

    public getWidgetData() {
        let filter: LoopBackFilter = <LoopBackFilter>{};
        filter['data'] = true;
        if (this.entityrecordid) { filter['entityrecordid'] = this.entityrecordid; }
        this.subscriptions.push(this._DataelementApi.findById(this.id, filter)
            .subscribe((result) => {
                if (result && result['data']) {
                    this.dataelement = result;

                    //If custom column definition is available , use it
                    if (this.dataelement.columndefinition) {
                        this.columns = JSON.parse(this.dataelement.columndefinition);
                    } else {
                        this.constructColumns(this.dataelement.fields);
                    }
                    this.replaceColumns();

                    if (this.dataelementrecords) {
                        let datarecords = JSON.parse(JSON.stringify(this.dataelementrecords));
                        if (Array.isArray(datarecords) || datarecords.length > 0) {
                            this.records = datarecords;
                        }
                    } else {
                        this.records = this.dataelement.data;
                    }

                    this.configureandloadgrid();
                }
            }));
    }

    ngOnDestroy() {
        for (let i = 0; i < this.subscriptions.length; i++) { this.subscriptions[i].unsubscribe(); }
    }

    protected notify(type, title?, content?, options?) {
        if (!options) { options = PlatformApp.getNotificationOptions(); }
        if (!options.id) { options.id = type + '-' + title + '_' + content; }
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/table/table.component.ts